<template>
  <div>
    <Input
      v-if="data.type === 'input'"
      v-model="condition[data.key]"
      clearable
      :placeholder="data.placeholder || data.label" />
    <!-- <Select
      v-if="data.type === 'select'"
      v-model="condition[data.key]"
      clearable
      :placeholder="data.placeholder || data.label">
      <Option
        v-for="opt in data.options"
        :key="opt.value"
        :value="opt.value">
        {{opt.label}}
      </Option>
    </Select> -->
    <Select
      v-if="data.type === 'select'"
      v-model="selVal"
      @on-change ="onShange"
      clearable
      :placeholder="data.placeholder || data.label">
      <Option
        v-for="opt in data.options"
        :key="opt.value"
        :value="opt.value">
        {{opt.label}}
      </Option>
    </Select>
    <!-- <DatePicker
      v-if="data.type.indexOf('date') === 0"
      :type="data.type"
      v-model="condition[data.key]"
      clearable
      :placeholder="data.placeholder || data.label"></DatePicker> -->
    <DatePicker
      v-if="data.type.indexOf('date') === 0"
      :type="data.type"
      v-model="timeVal"
      @on-change ="onThange"
      clearable
      :placeholder="data.placeholder || data.label"></DatePicker>
    <org-select
      class="org-select"
      v-if="data.type === 'orgselect'"
      v-model="condition[data.key]"
      :rootOrgId="orgCondition.rootOrgId"
      :nodeHandler="orgCondition.nodeHandler"
      :trackHandler="orgCondition.trackHandler"
      :load="orgCondition.load"
      :rootHandler="orgCondition.rootHandler" />
</div>
</template>
<script>
export default {
  name: 'SearchItem',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    condition: {
      type: Object,
      default: () => ({}),
    },
    orgCondition: {
      type: Object,
      default: () => ({
        rootOrgId: '',
        nodeHandler() {},
        trackHandler() {},
        load() {},
        rootHandler() {},
      }),
    },
  },
  data() {
    return {
      timeVal: '',
      selVal: '',
    }
  },
  // computed: {
  //   timeVal() {
  //     return this.condition.drugTime
  //   },
  // },
  // watch: {
  //   condition: {
  //     handler(newVal) {
  //       if (newVal.drugTime) {
  //         this.$set(this.condition, 'drugTime', '')
  //         // this.condition['drugTime'] = ''
  //       }
  //       console.log('pppppppppppppppppppppppp', this.condition)
  //     },
  //   },
  // },
  methods: {
    onThange(v) {
      this.timeVal = v
      this.condition.drugTime = v
    },
    onShange(v) {
      this.selVal = v
      this.condition.drugTemp = v
    },
  },
}
</script>
<style lang="scss" scoped>
$WIDTH-100: 100%;
.org-select{
  width: $WIDTH-100;
  /deep/ .org-selector{
    width: $WIDTH-100 !important;
  }
}
</style>